module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/rewards/cyclebar-b84f6e67c272ecd29e1c016810bde6d8.svg";